import styled from 'styled-components';
import { colors } from '@10d/tend-ui-tokens/samolet';

import WaveIcon from './wave.svg';

export const Wrapper = styled.div`
  position: absolute;
  left: 0;
  top: 70px;
  bottom: 0;
  right: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: none;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(4px);
`;

export const Whale = styled.img`
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1000;
`;

export const Text = styled.div`
  position: relative;
  margin-top: 45px;
  font-weight: 700;
  font-size: 28px;
`;

export const OceanWrapper = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  overflow: hidden;
`;

export const Ocean = styled.div<{ percent: number }>`
  height: 100%;
  transition: transform 0.6s ease;
  transform: translateY(${props => 95 - props.percent * 0.95}%);
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  background: ${colors.blue300}
    linear-gradient(to bottom, ${colors.blue300}, ${colors.blue300} 20%, #66b0fd);
`;

export const Wave = styled.div`
  background: url(${WaveIcon}) repeat-x;
  background-size: auto 100px;
  position: absolute;
  bottom: 100%;
  width: 6400px;
  height: 100px;
  animation: wave 5s cubic-bezier(0.36, 0.45, 0.63, 0.53) infinite;
  transform: translate3d(0, 0, 0);

  &:nth-of-type(2) {
    bottom: 95%;
    animation:
      wave 5s cubic-bezier(0.36, 0.45, 0.63, 0.53) -0.125s infinite,
      swell 5s ease -0.25s infinite;
    opacity: 1;
  }

  @keyframes wave {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-1600px);
    }
  }

  @keyframes swell {
    0%,
    100% {
      margin-bottom: 20px;
    }
    50% {
      margin-bottom: -5px;
    }
  }
`;
